module.exports = {
  brand: 'mcom',
  priceToggletip: {
    text: 'Last Act items are final sale and cannot be returned. Extra savings do not apply.',
    link: 'https://customerservice-macys.com/articles/what-is-macys-return-policy#Last-Act-Merchandise',
  },
  ccfp: {
    cardTitle: "Macy's Card",
    brand: "Macy's",
    image: 'https://assets.macysassets.com/feature/credit-gateway/latest/images/double-amex-card.png',
    faqLink: 'https://customerservice-macys.com/articles/payment-allocation',
    learnMoreLink: 'https://customerservice-macys.com/articles/do-you-offer-financing-for-fine-jewelry-purchases',
  },
  klarna: {
    minProductPrice: 10,
    maxProductPrice: 1000,
  },
  latchkey: { // TODO remove once mcom and bcom has parity
    label: 'Foundation:',
    minCountToShowDropdown: 0,
  },
  analytics: {
    price: {
      details: {
        eventName: 'special offer click',
        payloadProperty: 'num_offers',
      },
    },
  },
};
